import React from 'react';
import { ChevronRight } from 'lucide-react';

export const ServiceSelection = ({ services, loading, onSelectService }) => {
  return (
    <div className="space-y-4 pt-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-6">בחר את השירות הרצוי</h2>
      <div className="grid grid-cols-1 gap-3">
        {loading ? (
          <div className="text-center py-8">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-rose-500 mx-auto"></div>
            <p className="text-gray-600 mt-2 text-sm">טוען שירותים...</p>
          </div>
        ) : services?.length > 0 ? (
          services
            .filter((service) => service.is_active && service.is_visible_to_customers)
            .map((service) => (
              <button
                key={service.id}
                onClick={() => onSelectService(service)}
                className="w-full bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50 backdrop-blur-sm border border-white/20 rounded-2xl p-4 shadow-lg hover:shadow-xl transition-all duration-300 hover:bg-white/80 text-right"
              >
                <div className="flex items-center gap-4">
                  <div className="text-2xl">{service.icon || '💆‍♀️'}</div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-900">{service.name}</h3>
                    <p className="text-sm text-gray-600 mb-2">{service.description || ''}</p>
                    <div className="flex items-center gap-4 text-xs text-gray-500">
                      <span>{service.duration} דקות</span>
                      {service.show_price_to_customers ? (
                        <span className="font-medium text-rose-600">₪{service.price}</span>
                      ) : (
                        <span className="font-medium text-gray-600">צור קשר למחיר</span>
                      )}
                    </div>
                  </div>
                  <ChevronRight className="w-5 h-5 text-gray-400" />
                </div>
              </button>
            ))
        ) : (
          <div className="text-center py-8">
            <div className="text-gray-400 mb-2">🔍</div>
            <p className="text-gray-600 text-sm">אין שירותים זמינים כרגע</p>
            <p className="text-gray-500 text-xs mt-1">נסה שוב מאוחר יותר</p>
          </div>
        )}
      </div>
    </div>
  );
};
